__turbopack_context__.v({
  "header": "BoardSectionItemMap-module-scss-module__Of5Biq__header",
  "map": "BoardSectionItemMap-module-scss-module__Of5Biq__map",
  "maxHeightWrapper": "BoardSectionItemMap-module-scss-module__Of5Biq__maxHeightWrapper",
  "wrapper": "BoardSectionItemMap-module-scss-module__Of5Biq__wrapper",
});
